import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import React from 'react';
import { Toaster } from 'sonner';

import { InmaculadaAPage } from './pages/InmaculadaAPage';
import { InmaculadaBPage } from './pages/InmaculadaBPage';
import { InmaculadaFemPage } from './pages/InmaculadaFemPage';
import { SelectionPage } from './pages/SelectionPage';
import { AdminPage } from './pages/fantasy/AdminPage';
import { FantasyHome } from './pages/fantasy/FantasyHome';
import { LoginFantasy } from './pages/fantasy/LoginFantasy';
import { AuthProvider } from './context/authContext';


function App() {
  return (
    <AuthProvider>
      <Toaster
        richColors
        closeButton
        position="top-center"
        duration={4000}
        toastOptions={{
          style: {
            fontFamily: "'Open_Sans_Extra', sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <>
          <Routes>
              <Route path="/" element={<SelectionPage />} />
              <Route path="inmaculadaA" element={<InmaculadaAPage />} />
              <Route path="inmaculadaB" element={<InmaculadaBPage />} />
              {/*<Route path="inmaculadaFem" element={<InmaculadaFemPage />} />*/}
              <Route path="fantasy/login" element={<LoginFantasy />} />
              <Route path="fantasy/home" element={<FantasyHome />} />
              {<Route path="fantasy/admin" element={<AdminPage />} />}
              <Route path="*" element={<SelectionPage />} />
          </Routes>
        </>
      </BrowserRouter>
    </AuthProvider>
  )
}

export default App